import { memo } from 'react';

// material-ui
import { Typography } from '@mui/material';

// third-party
import { FormattedMessage } from 'react-intl';

// project imports
import { useSelector } from 'store';
import NavGroup from './NavGroup';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { sideMenu } = useSelector((state) => state.main);

    return sideMenu?.map((item) => {
        switch (item?.type) {
            case 'group':
                return <NavGroup key={item.id} group={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        <FormattedMessage id="menuitems-error" />
                    </Typography>
                );
        }
    });
};

export default memo(MenuList);
